/* ＿人人人人人人人人人人人人＿
*  ＞　ボタンコンポーネント　＜
*  ￣Ｙ^Ｙ^Ｙ^Ｙ^Ｙ^Ｙ^Ｙ^Ｙ￣ */
<template>
	<button :type="type" class="dc-ct-button" @click="click">{{ text }}</button>
</template>

<script>
import base from '@/components/base.vue';
export default {
	mixins: [base],
	name: "ct-button",
	props: {
		text: {},
		type: {}
	},
	methods: {
		click(e) {
			this.$emit('click', e);
		}
	}
}
</script>

<style lang="less">
@import '../../less/const.less';
.dc-ct-button {
	.border('', 1px, @color-bg-base);
	.radius('', 4px);
	background-color: @color-bg-dark;
	padding: 2px 3px;
	box-sizing: border-box;
	cursor: pointer;
	outline: 0;
	color: lighten(@color-bg-base, 36%);
	
	&:disabled {
		color: @color-light-text;
		cursor: default;
	}
}

@-moz-document url-prefix() {
	.mac {
		.dc-ct-button {
			/* padding: 2px 0; */
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/component/button.vue